'use client'

// src/context/useQueue.ts
import { useContext, useEffect } from "react";

// src/context/context.tsx
import { createContext } from "react";
var defaultQueueState = {
  isActive: false,
  queue: void 0,
  slug: void 0,
  autoRefresh: false,
  canJumpQueue: false,
  initQueue: () => {
  },
  setAutoRefresh: () => {
  }
};
var QueueContext = createContext(defaultQueueState);
var context_default = QueueContext;

// src/context/useQueue.ts
var useQueue = (options) => {
  const context = useContext(context_default);
  if (!context) throw new Error("useQueue must be used within QueueProvider");
  useEffect(() => {
    const timeout = setTimeout(() => {
      var _a;
      if ((options == null ? void 0 : options.autoRefresh) !== void 0) {
        (_a = context.setAutoRefresh) == null ? void 0 : _a.call(context, options.autoRefresh);
      }
    }, 1e3);
    return () => clearTimeout(timeout);
  }, [options == null ? void 0 : options.autoRefresh]);
  return context;
};
var useQueue_default = useQueue;

export {
  context_default,
  useQueue_default
};
//# sourceMappingURL=chunk-XG65SW5G.mjs.map